import script from "./AgreementSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementSection.vue?vue&type=script&setup=true&lang=js"

import "./AgreementSection.vue?vue&type=style&index=0&id=648fe3c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648fe3c5"]])

export default __exports__